import React from 'react';

import SignUpBanner from '../Banners/SignUp';
import { Layout } from '../common';
import { MetaData } from '../common/meta';
import { Article } from '../InnerPages/Article';

import style from './Layout.scss';

interface IInnerPageLayoutProps {
  className?: string;
  children?: React.ReactNode;
  articleHTML: string;
  pageTitle?: string;
  pageDescription?: string;
  location: any;
  isSignupShown?: boolean;
}

export const InnerPageLayout = ({
  isSignupShown = true,
  location,
  pageTitle,
  pageDescription,
  children,
  articleHTML,
}: IInnerPageLayoutProps) => (
  <>
    <MetaData data={{}} location={location} title={pageTitle} description={pageDescription} />
    <Layout headerClassName={style.header} mainClass={style.main}>
      {children}
      <Article html={articleHTML} />

      {isSignupShown && <SignUpBanner />}
    </Layout>
  </>
);
